"use client";

import type React from "react";
import NextLink from "next/link";
import { useBlockableRouter } from "@/components/navigation-block";

type LinkProps = React.ComponentProps<typeof NextLink>;

export default function Link({
  href,
  replace,
  target,
  onClick,
  children,
  ...rest
}: LinkProps) {
  const router = useBlockableRouter();

  return (
    <NextLink
      href={href}
      replace={replace}
      target={target}
      onClick={(event) => {
        onClick?.(event);

        if (event.defaultPrevented) {
          return;
        }

        const isModifiedClick =
          event.metaKey ||
          event.ctrlKey ||
          event.shiftKey ||
          event.altKey ||
          event.button !== 0;

        if (isModifiedClick || target === "_blank") {
          return;
        }

        event.preventDefault();

        if (replace) {
          router.replace(href.toString());
          return;
        }

        router.push(href.toString());
      }}
      {...rest}
    >
      {children}
    </NextLink>
  );
}
